"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductBoxSkeleton = void 0;
var _react = _interopRequireDefault(require("react"));
var _ProductBox = require("../ProductBox");
var _ProductBoxSkeletonList = require("./ProductBoxSkeletonList");
var _ProductBoxSkeletonTable = require("./ProductBoxSkeletonTable");
var _ProductBoxSkeletonTile = require("./ProductBoxSkeletonTile");
require("../ProductBox/ProductBox.scss");
require("../ProductBox/common/ImageLink/ImageLink.scss");
require("../ProductBox/common/Title/Title.scss");
var ProductBoxSkeleton = function ProductBoxSkeleton(_ref) {
  var className = _ref.className,
    skeletonRef = _ref.skeletonRef,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? _ProductBox.PRODUCT_BOX_STYLE_TYPE.tile : _ref$styleType;
  var ProductBoxSkeletonList = ProductBoxSkeleton.ProductBoxSkeletonList,
    ProductBoxSkeletonTable = ProductBoxSkeleton.ProductBoxSkeletonTable,
    ProductBoxSkeletonTile = ProductBoxSkeleton.ProductBoxSkeletonTile;
  switch (styleType) {
    case _ProductBox.PRODUCT_BOX_STYLE_TYPE.list:
      return /*#__PURE__*/_react["default"].createElement(ProductBoxSkeletonList, {
        className: className,
        skeletonRef: skeletonRef
      });
    case _ProductBox.PRODUCT_BOX_STYLE_TYPE.tile:
      return /*#__PURE__*/_react["default"].createElement(ProductBoxSkeletonTile, {
        className: className,
        skeletonRef: skeletonRef
      });
    case _ProductBox.PRODUCT_BOX_STYLE_TYPE.table:
    default:
      return /*#__PURE__*/_react["default"].createElement(ProductBoxSkeletonTable, {
        className: className,
        skeletonRef: skeletonRef
      });
  }
};
exports.ProductBoxSkeleton = ProductBoxSkeleton;
ProductBoxSkeleton.ProductBoxSkeletonList = _ProductBoxSkeletonList.ProductBoxSkeletonList;
ProductBoxSkeleton.ProductBoxSkeletonTable = _ProductBoxSkeletonTable.ProductBoxSkeletonTable;
ProductBoxSkeleton.ProductBoxSkeletonTile = _ProductBoxSkeletonTile.ProductBoxSkeletonTile;
ProductBoxSkeleton.config = {
  styleType: _ProductBox.PRODUCT_BOX_STYLE_TYPE
};